export const GET_MEMBER = 'member/GET_MEMBER'
export const GET_MEMBER_SUCCESS = 'member/GET_MEMBER_SUCCESS'
export const GET_MEMBER_ERROR = 'member/GET_MEMBER_ERROR'

export const DELETE_MEMBER = 'member/DELETE_MEMBER'
export const DELETE_MEMBER_SUCCESS = 'member/DELETE_MEMBER_SUCCESS'
export const DELETE_MEMBER_ERROR = 'member/DELETE_MEMBER_ERROR'

export const RESEND_INVITE = 'member/RESEND_INVITE'
export const RESEND_INVITE_SUCCESS = 'member/RESEND_INVITE_SUCCESS'
export const RESEND_INVITE_ERROR = 'member/RESEND_INVITE_ERROR'

export const GET_SERVICE_TYPES = 'member/GET_SERVICE_TYPES'
export const GET_SERVICE_TYPES_SUCCESS_MEMBER = 'member/GET_SERVICE_TYPES_SUCCESS'
export const GET_SERVICE_TYPES_ERROR = 'member/GET_SERVICE_TYPES_ERROR'

export const VALIDATE_PHONE_NUMBER = 'member/VALIDATE_PHONE_NUMBER'
export const VALIDATE_PHONE_NUMBER_SUCCESS = 'member/VALIDATE_PHONE_NUMBER_SUCCESS'
export const VALIDATE_PHONE_NUMBER_ERROR = 'member/VALIDATE_PHONE_NUMBER_ERROR'

export const SET_MEMBER_ACTIVATION = 'member/SET_MEMBER_ACTIVATION'
export const SET_MEMBER_ACTIVATION_ERROR = 'member/SET_MEMBER_ACTIVATION_ERROR'
export const SET_MEMBER_ACTIVATION_SUCCESS = 'member/SET_MEMBER_ACTIVATION_SUCCESS'
export const OVERWRITE_MEMBER_PRODUCTIVITY = 'member/OVERWRITE_MEMBER_PRODUCTIVITY'
export const OVERWRITE_MEMBER_PRODUCTIVITY_SUCCESS = 'member/OVERWRITE_MEMBER_PRODUCTIVITY_SUCCESS'
export const OVERWRITE_MEMBER_PRODUCTIVITY_ERROR = 'member/OVERWRITE_MEMBER_PRODUCTIVITY_ERROR'
export const SET_IS_PRODUCTIVITY_OVERWRITTEN_SUCCESS = 'member/SET_IS_PRODUCTIVITY_OVERWRITTEN_SUCCESS'

export const RESET = 'member/RESET'

export const CLEAR_RESEND_SUCCESS = 'member/CLEAR_RESEND_SUCCESS'

export const SET_MEMBER = 'member/SET_MEMBER'
export const SET_ERROR = 'member/SET_ERROR'
export const SET_PHONE_VALIDATION = 'member/SET_PHONE_VALIDATION'
export const SET_EDITED_MEMBER_DATA = 'member/SET_EDITED_MEMBER_DATA'
